// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PZI7P","toggleWrap":"styles_toggleWrap__12jzf","content":"styles_content__1DPC0","selectAreaCode":"styles_selectAreaCode__2LJmA"};